'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDollarsPerHour = exports.formatDollars = exports.formatCentsToDollars = exports.dollarsToCents = exports.centsToDollars = undefined;

var _big = require('big.js');

var _big2 = _interopRequireDefault(_big);

var _round = require('../round');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberWithCommas = function numberWithCommas(number) {
  return new _big2.default(number).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var nullOrUndefined = function nullOrUndefined(x) {
  return typeof x === 'undefined' || x === null;
};

var centsToDollars = exports.centsToDollars = function centsToDollars(cents) {
  return (0, _round.roundToTwoDecimalPlaces)(new _big2.default(cents / 100));
};

var dollarsToCents = exports.dollarsToCents = function dollarsToCents(dollars) {
  return (0, _round.roundToZeroDecimalPlaces)(new _big2.default(dollars * 100));
};

var formatCentsToDollars = exports.formatCentsToDollars = function formatCentsToDollars(cents) {
  if (nullOrUndefined(cents)) return '$—';
  return '$' + numberWithCommas(centsToDollars(cents || 0));
};

var formatDollars = exports.formatDollars = function formatDollars(dollars) {
  if (nullOrUndefined(dollars)) return '$—';
  return '$' + numberWithCommas(dollars || 0);
};

var formatDollarsPerHour = exports.formatDollarsPerHour = function formatDollarsPerHour(dollarsPerHour) {
  return formatDollars(dollarsPerHour) + '/hr';
};